import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEvent, ColumnEditorOptions } from "primereact/column";
import { InputText } from "primereact/inputtext";

interface ColumnMeta {
  field: string;
  header: string;
}

export default function EditableDataTable() {
  const [data, setData] = useState<any[]>([]);
  const [columns, setColumns] = useState<ColumnMeta[]>([]);

  const onCellEditComplete = (e: ColumnEvent) => {
    let { rowData, newValue, field, rowIndex } = e;
    const oldData = [...data];
    const newRow = { ...rowData, [field]: newValue };
    oldData[rowIndex] = newRow;
    setData(oldData);
  };

  const textEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (options.editorCallback) {
            options.editorCallback(e.target.value);
          }
        }}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    const rows = text.split("\n").filter((row) => row.trim() !== "");
    if (rows.length === 0) return;

    const headerLine = rows[0];
    const headers = headerLine.split("\t");

    const newColumns = headers.map((header) => ({
      field: header.trim(),
      header: header.trim(),
    }));

    const newData = rows.slice(1).map((row) => {
      const values = row.split("\t");
      const rowData: { [key: string]: any } = {};
      headers.forEach((header, index) => {
        rowData[header.trim()] = values[index] || "";
      });
      return rowData;
    });

    setColumns(newColumns);
    setData(newData);
  };

  return (
    <div className="card p-fluid" onPaste={handlePaste}>
      <p>Paste your CSV/Excel data here.</p>
      <DataTable
        value={data}
        editMode="cell"
        tableStyle={{ minWidth: "50rem" }}
      >
        {columns.map(({ field, header }) => {
          return (
            <Column
              key={field}
              field={field}
              header={header}
              style={{ width: "25%" }}
              editor={(options) => textEditor(options)}
              onCellEditComplete={onCellEditComplete}
            />
          );
        })}
      </DataTable>
    </div>
  );
}
